import React from 'react';
import { useTranslation } from 'next-i18next';

import PlainButton from 'src/shared/components/PlainButton';
import Section from 'src/shared/components/Section';
import Link from 'src/shared/components/Link';

import { LeaderInfoType } from './types/leaderInfoType';
import useAltiveLeaderInfo from './hooks/useAltiveLeaderInfo';

import styles from './styles.module.scss';
import { fireGA } from 'src/utils/gaUtils';

const SECTION_CONTAINER_STYLE = { height: '100%', padding: 0 };

const LeaderCard: (leaderInfo: LeaderInfoType) => JSX.Element = ({ name, title, description, href, image }) => {
    const onLinkedInClick = () => {
        fireGA('marketingQ421', 'clickTeamThumbnail', name);
    };

    return (
        <div className={styles.leaderCard}>
            <div className={styles.avatarContainer}>
                <PlainButton clear onClick={onLinkedInClick}>
                    <Link href={href}>
                        <a target="_blank">
                            <img src={image} className={styles.avatar} alt="Avatar" />
                            <div className={styles.linkedinCirle}>
                                <i className={`icon-btn_footer_linkedin ${styles.icon}`} />
                            </div>
                        </a>
                    </Link>
                </PlainButton>
            </div>
            <div className={styles.leaderDetails}>
                <div className={styles.name}>{name}</div>
                <div className={styles.title}>{title}</div>
                <div className={styles.description}>{description}</div>
            </div>
        </div>
    );
};

const LeadershipSection = () => {
    const { t } = useTranslation();
    const AltiveLeaderInfos = useAltiveLeaderInfo();

    return (
        <Section className={styles.section} fullWidth containerStyle={SECTION_CONTAINER_STYLE}>
            <div className={styles.layer}>
                <div className={styles.sectionTitle}>{t('who_we_are_team_title')}</div>

                <div className={styles.teamSectionTitle}>{t('who_we_are_team_section_title_1')}</div>
                <div className={styles.leaderList}>
                    {AltiveLeaderInfos.map((AltiveLeaderInfo: LeaderInfoType, idx) => (
                        <LeaderCard key={`leader-card-${idx}`} {...AltiveLeaderInfo} />
                    ))}
                </div>
            </div>
        </Section>
    );
};

LeadershipSection.defaultProps = {
    showAboutButton: true,
};

export default LeadershipSection;
